import { EmployeeRolesEnum } from '@gtpl/shared-models/common-models';
import { ApiProperty } from '@nestjs/swagger';
export class PoFilterData {
    @ApiProperty()
    fromDate: string;
    @ApiProperty()
    toDate: string;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    role: EmployeeRolesEnum;

    /**
     * 
     * @param fromDate 
     * @param toDate 
     * @param unitId 
     */
    constructor(fromDate: string, toDate: string, unitId: number, role: EmployeeRolesEnum) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.unitId = unitId;
        this.role = role;
    }
}